const efs = {
  id: 'efs',
  name: 'English Fluency School',
  shortName: 'EFS',
  domain: 'https://thefluencyschool.com',
  tagline: 'Fluency through real conversation',
  // Espejo de src/config/schools/languages.js — ese archivo es la fuente que lee
  // gatsby-config.js. Si cambia uno, cambia el otro.
  defaultLanguage: 'es',
  supportedLanguages: ['en', 'es'],
  contact: {
    support: 'support@englishfluencyschool.com',
    payments: 'payments@englishfluencyschool.com',
    tutor: 'vic@englishfluencyschool.com',
    info: 'info@englishfluencyschool.com',
  },
  social: {
    instagram: 'https://instagram.com/englishfluencyschool',
    youtube: 'https://youtube.com/@englishfluencyschool',
  },
  calendly: 'https://calendly.com/englishfluencyschool/sessions',
  colors: {
    primary: '#E76F51',
    dark: '#0F172A',
    light: '#F8FAFC',
    accent: '#94A3B8',
    legacyBlue: '#115173',
    legacyOrange: '#FA9F25',
  },
  assets: {
    logo: '/images/Logo/Logo SFS.png',
    icon: '/images/Logo/Logo Icon SFS.png',
    ogImage: '/og-image.jpg',
    favicon: '/favicon.ico',
  },
  manifest: {
    themeColor: '#115173',
    backgroundColor: '#ffffff',
    icon: 'static/images/Logo/Logo Icon SFS.png',
  },
  seo: {
    titleSuffix: '| English Fluency School',
    ogSiteName: 'English Fluency School',
  },
  // Encuadre de la oferta pública — ver
  // project-log/initiatives/active/direccion-oferta-sin-precios.md
  // showPrices oculta el número en la UI pública. NUNCA borra priceMonthly del
  // JSON de contenido: ese campo alimenta PlanConfigTab, CycleSetupWizard,
  // PlanChangeRequestModal y PaymentOptionsModal. Revertir = true.
  marketing: {
    showPrices: false,
    showImmersionInOffer: false,
    heroMedia: {
      type: 'image',
      src: '/images/Team/eli-team.jpeg',
      alt: 'Elizabeth García',
    },
  },
  features: {
    blog: true,
    vocabularyVault: true,
    projects: true,
    calendly: true,
  },
  ai: {
    schoolId: 'efs',
    teachingLanguage: 'en',
    studentNativeLanguage: 'es',
    schoolName: 'English Fluency School',
    agentName: 'The Compass',
  },
};

export default efs;
